import { createTheme } from "@mui/material/styles";
import { purple } from "@mui/material/colors";

/** Prevents outlined input border from showing through the shrunk label on first focus. Applied to all labels so it works in Dialog/portal and when variant is not set. */
const outlinedInputLabelOverrides = {
    MuiInputLabel: {
        styleOverrides: {
            root: ({ theme }: { theme: { palette: { background: { paper: string } } } }) => ({
                backgroundColor: theme.palette.background.paper,
                paddingLeft: 4,
                paddingRight: 4,
                "&.MuiInputLabel-shrink": {
                    backgroundColor: theme.palette.background.paper,
                },
            }),
        },
    },
};

export const liveModeTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 1024,
            lg: 1536,
            xl: 1536,
        },
    },
    palette: {
        primary: {
            main: "#546e7a",
            light: "#819ca9",
            dark: "#29434e",
        },
        secondary: {
            main: "#0277bd",
            light: "#58a5f0",
            dark: "#004c8c",
        },
        background: {
            paper: "#ffffff",
        },
    },
    cardStatus: {
        opened: "#cccccc",
        unopened: "#f0f0f0",
        readonly: "#cccccc",
    },
    components: outlinedInputLabelOverrides,
});

export const demoModeTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 1024,
            lg: 1536,
            xl: 1536,
        },
    },
    palette: {
        primary: purple,
        secondary: purple,
        background: {
            default: "#fefef3",
            paper: "#faf8fe",
        },
    },
    cardStatus: {
        opened: "#cccccc",
        unopened: "#f0f0f0",
        readonly: "#cccccc",
    },
    components: outlinedInputLabelOverrides,
});

export const CONTROL_MARGIN = "dense";
